import { render, staticRenderFns } from "./QuotationFormBasicContact.vue?vue&type=template&id=0edcfd74&"
import script from "./QuotationFormBasicContact.vue?vue&type=script&lang=js&"
export * from "./QuotationFormBasicContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0edcfd74')) {
      api.createRecord('0edcfd74', component.options)
    } else {
      api.reload('0edcfd74', component.options)
    }
    module.hot.accept("./QuotationFormBasicContact.vue?vue&type=template&id=0edcfd74&", function () {
      api.rerender('0edcfd74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/RequestAQuote/QuotationForm/QuotationFormBasicContact.vue"
export default component.exports